import {
    DatiqGraphAxisDateTypes,
    DatiqGraphAxisType,
} from './datiq-graph.enum';
import { datGrey } from '@dat/datiq-components-pkg/utils';
import {
    datiqGetDateStringDaily,
    datiqGetDateStringMonthly,
    datiqGetDateStringWeekly,
    datiqGetDateStringYearly,
} from '@dat/datiq-core/models';
import { DatiqGraphSeriesDataTypes } from './datiq-graph.interface';
import { DateTime } from 'luxon';

export const DATIQ_GRAPH_CREATE_AXIS_PREFIX = 'createAxis';
export const datiqGraphCreateAxisMethodName: (
    axisType: DatiqGraphAxisType
) => string = (axisType: DatiqGraphAxisType) =>
    `${DATIQ_GRAPH_CREATE_AXIS_PREFIX}${axisType}`;

export const DATIQ_GRAPH_PROPS_COLOR: string[] = ['stroke', 'fill'];

export const DATIQ_GRAPH_PROPS_DATE_FORMATS: string[] = [
    'dateFormats',
    'periodChangeDateFormats',
];

export const DATIQ_GRAPH_AXIS_FILL_KEYS: string[] = ['fill', 'fillOpacity'];

export const DATIQ_GRAPH_LABEL_COLOR = datGrey[500];
export const datiqGetGraphDateLabel = (
    x: DatiqGraphSeriesDataTypes,
    type: DatiqGraphAxisDateTypes,
    goForward?: boolean,
): string => {
    return type === DatiqGraphAxisDateTypes.Daily
        ? datiqGetDateStringDaily(x as Date)
        : type === DatiqGraphAxisDateTypes.Weekly
        ? datiqGetDateStringWeekly(x as Date, goForward)
        : type === DatiqGraphAxisDateTypes.Monthly
        ? datiqGetDateStringMonthly(x as Date)
        : type === DatiqGraphAxisDateTypes.Yearly
        ? datiqGetDateStringYearly(x as Date)
        : type === DatiqGraphAxisDateTypes.BiYearly
        ? datiqGetDateStringMonthly(x as Date)
        : datiqGetDateStringDaily(x as Date);
};
export const datiqGetGraphDateCategoryDaily = (date: Date): string => {
    return DateTime.fromJSDate(date).toFormat('MM/dd/yyyy');
};
export const datiqGetGraphDateCategoryMonthly = (date: Date): string => {
    return DateTime.fromJSDate(date).toFormat('MMM `yy');
};
export const datiqGetGraphDateCategoryWeekly = (date: Date): string => {
    return DateTime.fromJSDate(date).toFormat('MM/dd/yyyy');
};
export const datiqGetGraphDateCategoryYearly = (date: Date): string => {
    return DateTime.fromJSDate(date).toFormat('yyyy');
};
